import { Component, type ErrorInfo, type ReactNode } from 'react'
import { Button, Result } from 'antd'

type Props = {
  children: ReactNode
  /** Custom fallback. Receives the error and a reset callback. */
  fallback?: (error: Error, reset: () => void) => ReactNode
  /** Tag used for log grouping. */
  scope?: string
}

type State = {
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[error-boundary]', error, {
      scope: this.props.scope ?? 'unknown',
      componentStack: info.componentStack,
    })
  }

  reset = (): void => {
    this.setState({ error: null })
  }

  override render(): ReactNode {
    if (this.state.error) {
      if (this.props.fallback) {
        return this.props.fallback(this.state.error, this.reset)
      }
      return (
        <Result
          status="error"
          title="Bir hata oluştu"
          subTitle={this.state.error.message || 'Beklenmeyen bir hata.'}
          extra={
            <Button type="primary" onClick={this.reset}>
              Yeniden Dene
            </Button>
          }
        />
      )
    }

    return this.props.children
  }
}
